import { useEffect, useState } from 'react';
import { DesktopLayout } from '../../components/Layouts';
import {
  Profile,
  // BillingDetails,
  BankAccount,
  // Preferences,
} from '../../components/Settings';

export default function Settings() {
  const [activeComponent, setActiveComponent] = useState('Profile');

  const sidebarItems = [
    { label: 'Profile', component: <Profile /> },
    // { label: 'Billing Details', component: <BillingDetails /> },
    { label: 'Bank Account', component: <BankAccount /> },
    // { label: 'Preferences', component: <Preferences /> },
  ];

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const agreementId = params.get('signed_agreement_id');
    if (agreementId) {
      setActiveComponent('Bank Account');
    }
    const tab = params.get('tab');
    if (tab) {
      setActiveComponent(tab);
    }
  }, []);

  return (
    <DesktopLayout>
      <section className="pt-20 sm:pt-24 px-4 sm:px-8 lg:px-16 xl:px-32 flex flex-col items-start gap-6 sm:gap-10 w-full">
        <header>
          <h5 className="text-xl sm:text-2xl font-bold">Settings</h5>
          <p className="text-neutral-600 text-xs sm:text-sm font-normal">
            Manage your account settings and set e-mail preferences.
          </p>
        </header>

        <main className="flex flex-col md:flex-row gap-4 sm:gap-6 p-4 sm:p-6 h-full border border-slate-200 w-full rounded-md">
          <nav className="flex md:flex-col text-sm font-medium text-slate-900 md:w-[200px] w-full overflow-x-auto">
            <div className="flex flex-row md:flex-col w-full">
              {sidebarItems.map((item, index) => (
                <div
                  key={index}
                  className={`px-4 py-2 cursor-pointer whitespace-nowrap ${
                    activeComponent === item.label ? 'bg-slate-100' : 'bg-white'
                  } rounded-md`}
                  onClick={() => setActiveComponent(item.label)}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </nav>

          <div className="hidden md:block w-[1px] bg-slate-200 self-stretch" />
          <div className="block md:hidden h-[1px] bg-slate-200 w-full my-2" />

          <div className="w-full">
            {
              sidebarItems.find((item) => item.label === activeComponent)
                ?.component
            }
          </div>
        </main>
      </section>
    </DesktopLayout>
  );
}
